module.exports = __webpack_public_path__ + "img/news-banner3.cfaa56b0.jpg";